<div class="mu-page">
  <header>
    <h1>{{ 'marketingUsers.title' | translate }}</h1>
    <p class="mu-subtitle">{{ 'marketingUsers.subtitle' | translate }}</p>
  </header>

  <div class="mu-filters">
    <input
      #searchBox
      type="text"
      class="mu-search"
      [value]="search()"
      [placeholder]="'marketingUsers.searchPlaceholder' | translate"
      (keyup.enter)="submitSearch(searchBox.value)"
      (blur)="searchBox.value !== search() && submitSearch(searchBox.value)"
    />
    <button type="button" class="mu-toggle" [class.is-on]="reachableOnly()" (click)="toggleReachable()">
      {{ 'marketingUsers.reachableOnly' | translate }}
    </button>
  </div>

  <!-- The heat strip: counts over the current search, click to filter. -->
  <div class="mu-heatstrip" role="group">
    <button
      type="button"
      class="mu-heat-chip"
      *ngFor="let entry of heatStrip()"
      [attr.data-segment]="entry.key"
      [class.is-on]="segment() === entry.key"
      (click)="toggleSegment(entry.key)"
    >
      <span class="mu-heat-dot"></span>
      {{ 'segments.key.' + entry.key | translate }}
      <b>{{ entry.count }}</b>
    </button>
  </div>

  <p *ngIf="failed()" class="mu-error" role="alert">{{ 'marketingUsers.loadFailed' | translate }}</p>
  <p *ngIf="loading()" class="mu-loading">{{ 'common.loading' | translate }}</p>

  <div class="mu-table-wrapper" *ngIf="!loading() && !failed()">
    <table class="mu-table">
      <thead>
        <tr>
          <th scope="col">{{ 'marketingUsers.member' | translate }}</th>
          <th scope="col">{{ 'marketingUsers.heat' | translate }}</th>
          <th scope="col">{{ 'marketingUsers.lastAction' | translate }}</th>
          <th scope="col">{{ 'marketingUsers.lastLogin' | translate }}</th>
          <th scope="col">{{ 'marketingUsers.sports' | translate }}</th>
          <th scope="col">{{ 'marketingUsers.reachable' | translate }}</th>
          <th scope="col" class="is-numeric">{{ 'marketingUsers.activities' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows()" [routerLink]="['/users', row.userId]" class="is-clickable">
          <td>
            <span class="mu-member">
              <span class="mu-avatar" [attr.data-segment]="row.segment">{{ initials(row.firstName, row.lastName) }}</span>
              <span>
                <b>{{ row.firstName }} {{ row.lastName }}</b>
                <small>{{ row.email }}</small>
                <small>{{ row.city }}<ng-container *ngIf="row.createdAt"> · {{ 'marketingUsers.since' | translate }} {{ row.createdAt }}</ng-container></small>
              </span>
            </span>
          </td>
          <td>
            <span class="mu-heat" [attr.data-segment]="row.segment">{{ 'segments.key.' + row.segment | translate }}</span>
          </td>
          <td class="mu-lastact">
            <ng-container *ngIf="row.lastActionKind; else neverActed">
              <b>{{ 'marketingUsers.' + row.lastActionKind | translate }} « {{ row.lastActionTitle }} »</b>
              <small>{{ 'marketingUsers.daysAgo' | translate: { days: row.lastActionDaysSince } }}</small>
            </ng-container>
            <ng-template #neverActed>
              <b class="mu-muted">{{ 'marketingUsers.noAction' | translate }}</b>
            </ng-template>
          </td>
          <td>{{ row.lastLoginAt ?? '—' }}</td>
          <td>
            <ng-container *ngIf="row.sports.length > 0; else noSports">
              <span class="mu-sport" *ngFor="let sport of row.sports">
                {{ sport.name }}
                <b *ngIf="sport.level !== null">{{ sport.level }}<ng-container *ngIf="sport.maxLevel">/{{ sport.maxLevel }}</ng-container></b>
              </span>
            </ng-container>
            <ng-template #noSports>
              <span class="mu-muted">{{ 'marketingUsers.noSport' | translate }}</span>
            </ng-template>
          </td>
          <td class="mu-push">
            <ng-container *ngIf="!row.hasPush">
              <span class="mu-pb is-no">{{ 'marketingUsers.noPushToken' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="row.hasPush && !row.hasCustomNotifications">
              <span class="mu-pb is-default">{{ 'marketingUsers.defaultSettings' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="row.hasPush && row.hasCustomNotifications">
              <span class="mu-pb" [class.is-ok]="row.pushMarketing !== false" [class.is-no]="row.pushMarketing === false">
                {{ 'marketingUsers.pushMarketing' | translate }}
              </span>
              <span class="mu-pb" [class.is-ok]="row.pushReminder !== false" [class.is-no]="row.pushReminder === false">
                {{ 'marketingUsers.pushReminder' | translate }}
              </span>
              <span class="mu-pb" [class.is-ok]="row.pushProximity !== false" [class.is-no]="row.pushProximity === false">
                {{ 'marketingUsers.pushProximity' | translate }}
              </span>
            </ng-container>
          </td>
          <td class="is-numeric">{{ row.involvedCount }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mu-pager" *ngIf="!loading() && !failed() && total() > pageSize">
    <button type="button" (click)="goTo(page() - 1)" [disabled]="page() === 1">‹</button>
    <span>{{ 'marketingUsers.pageOf' | translate: { page: page(), last: lastPage(), total: total() } }}</span>
    <button type="button" (click)="goTo(page() + 1)" [disabled]="page() === lastPage()">›</button>
  </div>

  <p class="mu-note">{{ 'marketingUsers.note' | translate }}</p>
</div>
